export const MILEAGE_REGEX = new RegExp('^([0-9]{1,3}(.?[0-9]{3})*)$');
// This regex checks if the name contains url
export const CONTAINS_URL_REGEX = new RegExp(
  '(http(s)?:\\/\\/.)?(www\\.)?[-a-zA-Z0-9@:%._\\+~#=]{2,256}\\.[a-z]{2,6}\\b([-a-zA-Z0-9@:%_\\+.~#?&=]*)',
);
export const IS_YES_NO_OR_NUMERIC_REGEX = new RegExp(/(^Ja$)|(^Nee$)|(^Oui$)|(^Non$)|(^\d+$)/);

export const MIN_ASQ_MESSAGE_LENGTH = 2;
export const MAX_ASQ_MESSAGE_LENGTH = 5000;
export const MAX_ASQ_NAME_LENGTH = 31;
export const MAX_ASQ_LOCATION_LENGTH = 100;
export const MAX_ASQ_MILEAGE_LENGTH = 10;

export const INTERNAL_REVIEWS_SYSTEM = 'INTERNAL_REVIEWS';

export const USP_ENERGY_ATTRIBUTE_KEY = 'energyLabel';
export const ANIMAL_CATEGORY_ID = 395;
export const DELIVERY_ATTRIBUTE = 'delivery';
export const PRICE_TYPE_ATTRIBUTE = 'priceType';
export const PRICE_TYPE_ATTRIBUTE_VALUE_NL = 'Lease';
export const PRICE_TYPE_ATTRIBUTE_VALUE_FR = 'Leasing';
export const LEASE_TYPE_ATTRIBUTE = 'leaseType';
export const LEASE_TYPE_ATTRIBUTE_VALUE_NL = 'Persoonlijke lening';
export const MINIMUM_ASKING_PRICE_LOW_BID_AUTOMOTIVE = 500000;
export const DEFAULT_LOW_BID_THRESHOLD = 0.9;
// Requires the number to end in 0 to eliminate the risk of false positives on things like years, postal codes, etc.
export const LOW_BID_REGEX =
  '(?:(?=.{5,}$)\\d+\\.\\d{3}|(\\s|€|^)((?!(1990|2000|2010|2020)(\\s|$))[1-9][0-9]{2,4}0(?!%))(\\W|$)|(?:\\d{1,3}(?:[.,]\\d{1,3})?[kK](?!\\s*[a-zA-Z])\\s?))';
export const SELLER_OTHER_ITEMS_LIMIT = 10;
export const SCHEDULER_AVAILABILITY_KEYS = ['dayOfWeek', 'startTime', 'endTime'];

export const CARAVAN_AND_CAMPING_L2_ID = 289;
export const ALT_TEXT_LENGTH_LIMIT = 125;
export const CONTACT_OPTION_TYPES = {
  ASQ: 'asq',
  BUY_IT_NOW: 'buyItNow',
  PHONE: 'phone',
  WEBSITE: 'website',
};

export const feedTypes = {
  FRANCHISE_DEALERS: 'FRANCHISE_DEALERS',
};

export const SELLER_TYPE = {
  CONSUMER: 'CONSUMER',
  TRADER: 'TRADER',
  UNKNOWN: 'UNKNOWN',
  ERROR: 'ERROR',
};

export const priceTypes = {
  FIXED: 'FIXED',
  FREE_BID: 'FREE_BID',
  MIN_BID: 'MIN_BID',
  EXCHANGE: 'EXCHANGE',
  FAST_BID: 'FAST_BID',
  FREE: 'FREE',
  NOTK: 'NOTK',
  NVT: 'NVT',
  RESERVED: 'RESERVED',
  SEE_DESCRIPTION: 'SEE_DESCRIPTION',
  ON_REQUEST: 'ON_REQUEST',
};
